export const SL: Record<string, string> = {
  efetivado: "Efetivado",
  cotacao: "Cotação enviada",
  analise: "Em análise",
  perdido: "Não efetivado",
  novo: "Novo",
};

export const SC: Record<string, string> = {
  efetivado: "b-ef",
  cotacao: "b-co",
  analise: "b-an",
  perdido: "b-pe",
  novo: "b-nv",
};

export const RAMOS = [
  "AUTO", "BIKE", "CONDOMÍNIO", "CYBER", "DEMOLIÇÃO", "EMPRESARIAL",
  "EQUIPAMENTOS", "FIANÇA", "GARANTIA", "MOTO", "OBRA", "RC", "RC OBRA",
  "RCP", "RESIDENCIAL", "RISCO DE ENGENHARIA", "SEGURO VIAGEM", "VIDA", "Outro",
];

export const MOTIVOS_PERDA = [
  "Preço — achou caro",
  "Preço — concorrente mais barato",
  "Adiou a decisão",
  "Não viu necessidade do seguro",
  "Já tem seguro em outra corretora",
  "Projeto cancelado ou adiado",
  "Sem retorno / sumiu",
  "Escolheu outra seguradora diretamente",
  "Outro motivo",
];

export type Visao = "tratativa" | "todos" | "efetivado" | "perdido";
